import { Box } from "@mui/material";
import { Login } from "../../components/Auth/Login";

export function Signin(){
    return(
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100vh"} width={"100vw"}>
            <Login/>
        </Box>
    )
}